KROWN.themeName = 'Split';
KROWN.themeVersion = '4.4.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
          e.target.classList.contains('button') ||
          e.target.classList.contains('product-item') ||
          e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));    
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{

      const cssStyle = document.querySelector('[id^="css-fix-height-"]');
      if (!cssStyle) {
        console.warn('Could not find css-fix-height element');
        return;
      }
      
      const sectionId = cssStyle.id.replace('css-fix-height-', '');
      const heightElement = document.getElementById(`fix-height-with-${sectionId}`);
      
      if (cssStyle && heightElement) {
        const fixCollectionHeight = () => {
          const height = heightElement.offsetHeight - 1;
          cssStyle.innerHTML = `@media screen and (min-width: 1025px), screen and (min-width: 769px) and (orientation: landscape) { 
            #fix-height-${sectionId} {
              height: ${height}px !important;
            }
          }`;
        };
        
        setTimeout(fixCollectionHeight, 100);
        window.addEventListener('resize', fixCollectionHeight);
      } else {
        console.warn('Missing required elements for height fixing');
      }
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

    class SiteFilterHandle extends HTMLElement {
        constructor(){
            super();
            const sidebar = document.getElementById(this.getAttribute('aria-controls'));
            this.addEventListener('click', e=>{
                if ( ! this.classList.contains('disable-sidebar') ) {
                    e.preventDefault();
                    this.setAttribute('aria-expanded', 'true');
                    sidebar.show();
                }
            })
            this.addEventListener('keyup', e=>{
                if ( e.keyCode == window.KEYCODES.RETURN ) {
                    this.setAttribute('aria-expanded', 'true');
                    sidebar.show();
                    sidebar.querySelector('.site-close-handle').focus();
                }
            })
        }
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

}

// Knitec - Size guide text between SIZE and COLOR swatches
  (function() {
    var sizeTexts = {
      'S/30': 'S/30 FITS JEANS WAIST FROM SIZE 28 TO 32.<br>28–29 ➝ Relaxed fit | 30 ➝ Standard fit | 31–32 ➝ Snug fit',
      'M/32': 'M/32 FITS JEANS WAIST FROM SIZE 30 TO 34.<br>30–31 ➝ Relaxed fit | 32 ➝ Standard fit | 33–34 ➝ Snug fit',
      'L/34': 'L/34 FITS JEANS WAIST FROM SIZE 32 TO 36.<br>32–33 ➝ Relaxed fit | 34 ➝ Standard fit | 35–36 ➝ Snug fit',
      'XL/36': 'XL/36 FITS JEANS WAIST FROM SIZE 34 TO 40.<br>34–35 ➝ Relaxed fit | 36 ➝ Standard fit | 37–40 ➝ Snug fit',
      'XXL/38': 'XXL/38 FITS JEANS WAIST FROM SIZE 36 TO 42.<br>36–37 ➝ Relaxed fit | 38 ➝ Standard fit | 39–42 ➝ Snug fit'
    };

    function insertSizeGuide(sr) {
      if (!sr || sr.querySelector('#size-guide-container')) return;

      var checkedInput = Array.from(sr.querySelectorAll('input:checked')).find(function(input) {
        return ((input.getAttribute('data-rubik-option-name') || '').trim().toLowerCase() === 'size');
      });
      
      var textContent = sizeTexts[checkedInput.value];
      if (!textContent) return;

      var sizeFieldset = null;
      sr.querySelectorAll('fieldset').forEach(function(fs) {
        var label = fs.querySelector('.rubik-swatch__option-name-label');
        if (label && label.textContent.trim().toUpperCase().startsWith('SIZE')) {
          sizeFieldset = fs;
        }
      });
      if (!sizeFieldset) return;

      var div = document.createElement('div');
      div.id = 'size-guide-container';
      div.style.cssText = 'margin: 25px 0 45px 0; padding: 0; width: 100%; box-sizing: border-box;';
      div.innerHTML =
        '<p style="margin: 0 0 10px 0; font-size: 14px; line-height: 1.6; white-space: pre-line;">' + textContent + '</p>' +
        '<a href="/pages/size-and-fit-guide" style="color: #000000; font-weight: bold; text-decoration: none; font-size: 14px;">📏 View SIZE & FIT GUIDE AND CALCULATOR</a>';

      sizeFieldset.parentNode.insertBefore(div, sizeFieldset.nextSibling);
    }

    function init() {
      var el = document.querySelector('rubik-swatch');
      if (!el || !el.shadowRoot) {
        setTimeout(init, 200);
        return;
      }
      var sr = el.shadowRoot;
      insertSizeGuide(sr);
      new MutationObserver(function() {
        insertSizeGuide(sr);
      }).observe(sr, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();// Knitec collection and product-page videos

function initializeKnitecVideos(container = document) {

  container.querySelectorAll('.product-card-video, .product-gallery-video').forEach(video => {

    if (video.dataset.knitecReady === 'true') return;
    video.dataset.knitecReady = 'true';

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Remove blurry Shopify poster
    video.removeAttribute('poster');

    // Show first sharp frame
    const showFirstFrame = () => {
      try {
        if (video.currentTime === 0) {
          video.currentTime = 0.01;
        }
      } catch(e){}
    };

    if (video.readyState >= 2) {
      showFirstFrame();
    } else {
      video.addEventListener('loadeddata', showFirstFrame, { once:true });
    }

    // Force autoplay on mobile
    const playVideo = () => {
      video.play().catch(()=>{});
    };

    // Force looping
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      playVideo();
    });

    const desktop = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    if (desktop) {

      const holder =
        video.closest('.product-item') ||
        video.closest('.product-gallery-item');

      if (holder) {

        holder.addEventListener('mouseenter', playVideo);

        holder.addEventListener('mouseleave', () => {
          video.pause();
          video.currentTime = 0.01;
        });

      }

    } else {

      const observer = new IntersectionObserver(entries => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {
            playVideo();
          } else {
            video.pause();
          }

        });

      }, { threshold:0.25 });

      observer.observe(video);

    }

  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeKnitecVideos);
} else {
  initializeKnitecVideos();
}

document.addEventListener('shopify:section:load', e => {
  initializeKnitecVideos(e.target);
});
// Keep the product video synchronized with the active mobile carousel slide
function updateMobileProductGalleryVideo() {

  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;

  const screenCenter = window.innerWidth / 2;

  document.querySelectorAll('.product-gallery-video').forEach(video => {

    const slide = video.closest('.product-gallery-item');
    if (!slide) return;

    const rect = slide.getBoundingClientRect();

    const isActiveSlide =
      rect.width > 0 &&
      rect.left <= screenCenter &&
      rect.right >= screenCenter &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight;

    if (isActiveSlide) {

      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (video.paused) {
        video.play().catch(() => {});
      }

    } else {

      if (!video.paused) {
        video.pause();
      }

    }

  });

}

// Check repeatedly because the Rubik carousel does not reliably emit a slide-change event
setInterval(updateMobileProductGalleryVideo, 200);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(updateMobileProductGalleryVideo, 500);
  });
} else {
  setTimeout(updateMobileProductGalleryVideo, 500);
}